<div class="loader-container">
    <app-loader *ngIf="loading"></app-loader>
    <app-modal-header *ngIf="modalStyle" [title]="'Bestelling wijzigen / organisatie'"></app-modal-header>
    <div [ngClass]="{ 'modal-body': modalStyle }">
        <div *ngIf="errorMessage" class="alert alert-danger d-flex align-items-center" role="alert">
            <div>{{ errorMessage }}</div>
        </div>
            
        <div class="row">
            <div class="col-6">
                <h5 class="fw-bold">School</h5>
                <div class="mb-3">
                    <label class="form-label">Naam</label>
                    <div class="inputWrap d-flex">
                        <input type="text" class="form-control" [class.is-invalid]="formErrors.organisation_name"
                            [(ngModel)]="item.organisation_name" placeholder="Mystic Falls High School" />
                            <button type="button" class="btn btn-light" (click)="selectOrganisation()"><i class="bi bi-search"></i></button>
                    </div>
                </div>
                <div class="mb-3" *ngIf="!item['id']">
                    <label class="form-label">Periode</label>
                    <select class="form-control" [class.is-invalid]="formErrors.period_id"
                        [(ngModel)]="item['period_id']">
                        <option value="" disabled>
                            Selecteer periode
                        </option>
                        <option *ngFor="let period of periods" [value]="period['id']">
                            {{period.name}}
                        </option>
                    </select>
                </div>
                <div class="mb-3">
                    <label class="form-label">Schoolsoort</label>
                    <select class="form-control" [class.is-invalid]="formErrors.organisation_type"
                        [(ngModel)]="item['organisation_type']">
                        <option value="" disabled>
                            Selecteer schoolsoort
                        </option>
                        <option value="po">
                            PO
                        </option>
                        <option value="so">
                            SO
                        </option>
                        <option value="vo">
                            VO
                        </option>
                        <option value="mbo">
                            MBO
                        </option>
                        <option value="other">
                            Overig
                        </option>
                    </select>
                </div>
                <div class="mb-3">
                    <label class="form-label">Locatie</label>
                    <input type="text" class="form-control" [(ngModel)]="item.organisation_location"
                        placeholder="Whitmore" />
                </div>
                <div class="mb-3">
                    <label class="form-label">Adres</label>
                    <input type="text" class="form-control" [class.is-invalid]="formErrors.organisation_address"
                        [(ngModel)]="item.organisation_address" placeholder="Landgoed Schaduwmeer 13" />
                </div>
                <div class="mb-3">
                    <label class="form-label">Postcode</label>
                    <input type="text" class="form-control" [class.is-invalid]="formErrors.organisation_postal_code"
                        [(ngModel)]="item.organisation_postal_code" placeholder="3947 XR" />
                </div>
                <div class="mb-3">
                    <label class="form-label">Plaats</label>
                    <input type="text" class="form-control" [class.is-invalid]="formErrors.organisation_city"
                        [(ngModel)]="item.organisation_city" placeholder="Duinhorst" />
                </div>
                <div class="mb-3">
                    <label class="form-label">Land</label>
                    <input type="text" class="form-control" [class.is-invalid]="formErrors.organisation_country"
                        [(ngModel)]="item.organisation_country" placeholder="Nederland" />
                </div>
            </div>
            <div class="col-6">
                <h5 class="fw-bold">Contact</h5>
                <div class="mb-3">
                    <label class="form-label">Contact</label>
                    <input type="text" class="form-control" [class.is-invalid]="formErrors.name"
                        [(ngModel)]="item.name" placeholder="Alaric Salzman"/>
                </div>
                <div class="mb-3">
                    <label class="form-label">E-mail</label>
                    <input type="text" class="form-control" [class.is-invalid]="formErrors.email"
                        [(ngModel)]="item.email" placeholder="a.salzman@mysticfalls.nl"/>
                </div>
                <div class="mb-3">
                    <label class="form-label">Vestigingsnummer</label>
                    <input type="text" class="form-control" [class.is-invalid]="formErrors.organisation_department_number"
                        [(ngModel)]="item.organisation_department_number" placeholder=""/>
                </div>
                <div class="mb-3">
                    <label class="form-label">Master identifier</label>
                    <input type="text" class="form-control" [class.is-invalid]="formErrors.organisation_master_identifier"
                        [(ngModel)]="item.organisation_master_identifier" placeholder=""/>
                </div>
            </div>
        </div>
        <div class="form-buttons">
            <button type="button" *ngIf="item['id']" class="btn btn-primary" (click)="save()">
                Opslaan
            </button>
        </div>
    </div>
</div>